/**
 * 앱 전용 확인·안내 모달 (promise)
 * AppConfirmHost 한 곳에서만 사용
 */
import { reactive } from 'vue'

type ConfirmOptions = {
  title?: string
  message: string
  confirmText?: string
  cancelText?: string
}

type AlertOptions = {
  title?: string
  message: string
  confirmText?: string
}

type ConfirmState = {
  open: boolean
  alertOnly: boolean
  title: string
  message: string
  confirmText: string
  cancelText: string
  resolve: ((ok: boolean) => void) | null
}

const state = reactive<ConfirmState>({
  open: false,
  alertOnly: false,
  title: '확인',
  message: '',
  confirmText: '확인',
  cancelText: '취소',
  resolve: null,
})

export const useAppConfirmState = () => state

export const appConfirm = (options: ConfirmOptions | string): Promise<boolean> => {
  const opts = typeof options === 'string' ? { message: options } : options
  return new Promise((resolve) => {
    if (state.open && state.resolve) {
      state.resolve(false)
    }
    state.alertOnly = false
    state.alertOnly = false
    state.title = opts.title || '확인'
    state.message = opts.message || ''
    state.confirmText = opts.confirmText || '확인'
    state.cancelText = opts.cancelText ?? '취소'
    state.resolve = resolve
    state.open = true
  })
}

/** 단일 확인 버튼 안내 (브라우저 alert 대체) */
export const appAlert = (options: AlertOptions | string): Promise<void> => {
  const opts = typeof options === 'string' ? { message: options } : options
  return new Promise((resolve) => {
    if (state.open && state.resolve) {
      state.resolve(false)
    }
    state.alertOnly = true
    state.title = opts.title || '안내'
    state.message = opts.message || ''
    state.confirmText = opts.confirmText || '확인'
    state.cancelText = ''
    state.resolve = () => resolve()
    state.open = true
  })
}

export const resolveAppConfirm = (ok: boolean) => {
  const fn = state.resolve
  state.open = false
  state.alertOnly = false
  state.resolve = null
  if (fn) fn(ok)
}